import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-top">
            <div className="footer-brand-column">
              <div className="footer-thq-footer-logo-wrapper-elm footer-logo-wrapper">
                <img
                  alt="image"
                  src="/side%20profile%20transparent%20cleaned%20up-200h.png"
                  className="footer-image"
                />
                <span className="footer-brand-name">Sycorax Cats</span>
              </div>
              <div className="footer-thq-footer-social-group-elm footer-social-group">
                <a
                  href="https://www.facebook.com/profile.php?id=61588276051338"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link1"
                >
                  <div
                    aria-label="Facebook"
                    className="footer-thq-footer-social-link-elm1 footer-social-link"
                  >
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M7 10v4h3v7h4v-7h3l1-4h-4V8a1 1 0 0 1 1-1h3V3h-3a5 5 0 0 0-5 5v2z"></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://www.instagram.com/kittles.lee/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link2"
                >
                  <div
                    aria-label="Instagram"
                    className="footer-thq-footer-social-link-elm2 footer-social-link"
                  >
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"></path>
                      <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0m7.5-4.5v.01"></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-nav-column">
              <h3 className="footer-column-title">Quick Links</h3>
              <nav className="footer-nav-list">
                <Link to="/queen" className="footer-navlink1">
                  <div className="footer-thq-footer-nav-link-elm1 footer-nav-link">
                    <span>Our Queen</span>
                  </div>
                </Link>
                <Link to="/kittens" className="footer-navlink2">
                  <div className="footer-thq-footer-nav-link-elm2 footer-nav-link">
                    <span>Current Litters</span>
                  </div>
                </Link>
                <Link to="/contact-us" className="footer-navlink3">
                  <div className="footer-thq-footer-nav-link-elm3 footer-nav-link">
                    <span>Contact Us</span>
                  </div>
                </Link>
              </nav>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-logic">
(function(){
  // No complex logic required for this static footer section.
  // Hover effects are handled via CSS as per requirements.
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
